module.exports = __webpack_public_path__ + "img/VillaLoreto_Golf.25756666.jpg";